// utils/cepUtils.js
export function unformatCEP(cep) {
    if (!cep) return ''; // Handle null/undefined cases
    return cep.replace(/[^\d]/g, ''); // Remove todos os caracteres que não são dígitos
}

export function formatCEP(cep) {
    if (!cep) return ''; // Handle null/undefined cases
    const digitsOnly = cep.replace(/[^\d]/g, '');
    if (digitsOnly.length === 8) {
        return digitsOnly.replace(/(\d{2})(\d{3})(\d{3})/, '$1.$2-$3');
    }
    return digitsOnly;
}